import {setTimeout} from "timers";
import {setTimeout} from "timers";
import {setTimeout} from "timers";
<template>
  <div v-if="$store.getters.getMobilePhoneActive">
    <v-flex xs12 md6>
      <v-card-text class="text-md-center text-xs-center">
        <v-form class="formOutline" ref="form" v-model="valid" lazy-validation>
          <v-flex xs1>{{$translate('EMAIL')}}</v-flex>
          <v-flex xs11>
            <v-text-field
              outline
              placeholder="Example: JohnDoe@mail.com"
              color="primary"
              :style="getFontProperty()"
              v-model="email"
              :rules="pinRules"
              :error-messages="errorMessage"
              required="required"
            ></v-text-field>
          </v-flex>
          <v-flex xs1>{{$translate('PASSWORD')}}</v-flex>
          <v-flex xs11>
            <v-text-field
              outline
              color="primary"
              :style="getFontProperty()"
              v-model="password"
              :rules="passRules"
              :error-messages="errorMessage"
              :append-icon="e4 ? 'visibility' : 'visibility_off'"
              @click:append="() => (e4 = !e4)"
              :type="e4 ? 'text':'password'"
              required="required"
            ></v-text-field>
          </v-flex>
        </v-form>

        <v-flex xs11 class="mt-2">
          <v-btn
            block
            round
            :disabled="disableButton"
            :loading="disableButton"
            large
            @click="submit"
            color="secondary"
          >{{$translate('LOGIN')}}</v-btn>
<!--          <GoogleLogin :params="clientIdGoogle" :renderParams="GoogleRenderParams" :onSuccess="googleLoginSucces"><v-btn block round large color="red">Google Login</v-btn></GoogleLogin>-->
        </v-flex>
        <v-flex xs11 class="mb-4 mt-2 pb-4">
          <router-link :to="{ name: 'Register'}">
            <v-btn block round large color="primary">{{$translate('REGISTER_LINDA')}}</v-btn>
          </router-link>
        </v-flex>
      </v-card-text>
    </v-flex>
    <v-flex xs12 md6>
      <v-card round class=" left-in elevation-0 ml-4">
        <v-card-text>
          <p
            class="fontSize"
            :style="getFontProperty()"
          >{{$translate('WELCOME_MESSAGE_TITLE')}},</p>
          <p
            class="fontSize"
            :style="getFontProperty()"
          >{{$translate('LOGIN_PERSONAL').replace(/accountName/g, $store.getters.getAccountInfo.AccountName)}}</p>
        </v-card-text>
      </v-card>
    </v-flex>
  </div>
  <div v-else>
    <v-dialog v-model="mailSendedDialog" max-width="320" persistent>
      <v-card>
        <v-card-text>{{ $translate("ACTIVATION_MAIL_IS_SEND") }} <b>{{this.email}}</b></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn round color="primary" @click="closeMailDialog">{{
            $translate("CLOSE")
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-container class="web_home_style">
      <v-flex xs10 class="elevation-2 mx-auto containerBackground max-width-big">
        <v-card class="elevation-0 transparent scrollingTrue">
          <v-layout row wrap align-center>
            <v-flex></v-flex>
          </v-layout>
          <v-layout class="mt-4 ml-2" row wrap>
            <v-flex xs12 md6>
              <v-card class="elevation-0 transparent mt-4">
                <v-layout justify-left>
                  <v-card round class=" left-in elevation-0 ml-4">
                    <v-card-text>
                      <p
                        class="fontSize"
                        :style="getFontProperty()"
                      >{{$translate('WELCOME_MESSAGE_TITLE')}},</p>
                      <p
                        class="fontSize"
                        :style="getFontProperty()"
                      >{{$translate('LOGIN_PERSONAL').replace(/accountName/g, $store.getters.getAccountInfo.AccountName)}}</p>
                    </v-card-text>
                  </v-card>
                </v-layout>
              </v-card>
              <v-img
                class="passportImage"
                :src="require('../assets/passportClosed.png')"></v-img>
            </v-flex>

            <v-flex xs12 md6>
              <v-card-text class="text-md-center text-xs-center">
                <v-form class="formOutline" ref="form" v-model="valid" lazy-validation>
                  <v-flex xs1>{{$translate('EMAIL')}}</v-flex>
                  <v-flex xs11>
                    <v-text-field
                      outline
                      placeholder="Example: JohnDoe@mail.com"
                      color="primary"
                      :style="getFontProperty()"
                      v-model="email"
                      :rules="pinRules"
                      :error-messages="errorMessage"
                      required="required"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs1>{{$translate('PASSWORD')}}</v-flex>
                  <v-flex xs11>
                    <v-text-field
                      outline
                      color="primary"
                      :style="getFontProperty()"
                      v-model="password"
                      :rules="passRules"
                      :error-messages="errorMessage"
                      :append-icon="e4 ? 'visibility' : 'visibility_off'"
                      @click:append="() => (e4 = !e4)"
                      :type="e4 ? 'text':'password'"
                      required="required"
                    ></v-text-field>
                  </v-flex>
                </v-form>
                <v-flex xs11 class="mt-2">
                  <v-btn
                    block
                    round
                    :disabled="disableButton"
                    :loading="disableButton"
                    large
                    @click="submit"
                    color="secondary"
                  >{{$translate('LOGIN')}}</v-btn>
                </v-flex>
                <v-layout align-center column>
                  <v-flex xs11 class="mt-2">
                    <GoogleLogin
                      :params="clientIdGoogle"
                      :onFailure="googleLoginFailure"
                      :onSuccess="googleLoginSucces">
                      <v-btn
                        depressed
                        class="text-capitalize"
                        large
                        style="width: 310px; padding: 8px !important;"
                      >
                        <v-layout row align-center ma-2>
                          <v-img
                            width="24px"
                            max-width="24"
                            max-height="24"
                            :src="require('../assets/logos/google.png')">
                          </v-img>
                          <v-layout justify-center>
                            <p class="ma-0 text-xs-center">login with Google</p>
                          </v-layout>
                        </v-layout>
                      </v-btn>
                    </GoogleLogin>
                  </v-flex>
                  <v-flex xs11>
                    <v-btn
                      @click="facebookLogin"
                      depressed
                      class="text-capitalize"
                      large
                      style="width: 310px; padding: 8px !important;"
                    >
                      <v-layout row align-center ma-2>
                        <v-img
                          width="24px"
                          max-width="24"
                          max-height="24"
                          :src="require('../assets/logos/facebook.png')">
                        </v-img>
                        <v-layout justify-center>
                          <p class="ma-0 text-xs-center">login with facebook</p>
                        </v-layout>
                      </v-layout>
                    </v-btn>
                  </v-flex>
                  <v-flex xs11>
                    <v-btn
                      @click="appleLogin"
                      depressed
                      class="text-capitalize"
                      large
                      style="width: 310px; padding: 8px !important;"
                    >
                      <v-layout row align-center ma-2>
                        <v-img
                          width="24px"
                          max-width="24"
                          max-height="24"
                          :src="require('../assets/logos/apple.png')">
                        </v-img>
                        <v-layout justify-center>
                          <p class="ma-0 text-xs-center">login with Apple</p>
                        </v-layout>
                      </v-layout>
                    </v-btn>
                  </v-flex>
                </v-layout>
                <v-flex xs11 class="mt-2" >
                  <v-layout row justify-center align-center>
                    <v-divider></v-divider>
                    <p class="mb-0 mr-2 ml-2">OR</p>
                    <v-divider></v-divider>
                  </v-layout>
                </v-flex>
                <p style="color: blue; cursor:pointer;" @click="forgotPassword">{{$translate('FORGOT_PASS')}}</p>
                <div v-if="userForgotPassword">
                  <v-flex xs11>
                    <v-card class="pa-2 mb-4">
                      <h4 style="text-align: left;">{{$translate('USER_FORGOT_PASSWORD')}}</h4>
                      <v-flex xs12 class="mt-2">
                        <v-btn
                          block
                          round
                          large
                          @click="resendLoginCodeEmail"
                          color="primary"
                        >{{$translate('RESEND_LOGIN_DETAILS')}}</v-btn>
                      </v-flex>
                    </v-card>
                  </v-flex>
                </div>
                <div v-if="userNotActivated">
                  <v-flex xs11>
                    <v-card class="pa-2 mb-4">
                      <h4 style="text-align: left;">{{$translate('USER_NOT_ACTIVATED_TEXT')}}</h4>
                      <v-divider></v-divider>
                      <h4 style="text-align: left;">{{$translate('USER_NOT_ACTIVATED_MAIL')}}<b>{{this.email}}</b></h4>
                      <v-flex xs12 class="mt-2">
                        <v-btn
                          block
                          round
                          large
                          @click="resendActivationEmail"
                          color="primary"
                        >{{$translate('RESEND_ACTIVATION')}}</v-btn>
                      </v-flex>
                    </v-card>
                  </v-flex>
                </div>
                <v-flex xs11 class="mb-4 mt-2 pb-4">
                  <router-link :to="{ name:'Register'}">
                    <v-btn block round large color="primary">{{$translate('REGISTER_LINDA')}}</v-btn>
                  </router-link>
                </v-flex>
              </v-card-text>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import GoogleLogin from 'vue-google-login';
import _ from 'lodash';
import { mapGetters } from 'vuex';
import CpHeader from './CpHeader';
import CpFooter from './CpFooter';
import appConfig from '../../config/app_config';
import UserObject from '../objects/UserObject.js';
import BaseObject from '../objects/BaseObject';
import BaseComponent from './base/BaseComponent.vue';
import { ui_helpers } from '../shared/ui_helpers';
import { store } from '../store';
import * as dssRequest from '../api/dssRequest';
import VFacebookLogin from 'vue-facebook-login-component'
import auth from "../store/modules/auth";

export default {
  mixins: [ui_helpers],
  name: 'Login',
  extends: BaseComponent,

  components: {
    CpHeader,
    CpFooter,
    GoogleLogin,
    VFacebookLogin,
  },

  computed: {
    ...mapGetters({
      _user: 'auth/user',
    }),
  },
  data() {
    return {
      clientIdGoogle: {
        client_id: '819961578899-kgl1peh7ij93tgrat26v8tgou8gtj95h.apps.googleusercontent.com',
      },
      FB: {},
      googleRenderParams: {
        width: 250,
        height: 50,
        longtitle: true,
      },
      userForgotPassword: false,
      mailSendedDialog: false,
      userNotActivated: false,
      mobilePhoneActive: false,
      // Form user from user login.
      userLogin: {},
      tmpUserType: '',
      uniqueId: '',
      email: '',
      password: '',

      // Data read from the database.
      errorMessage: [],

      // Variables.
      e4: false,
      disableButton: false,
      valid: true,
      loginSuccess: false,

      // Rules.
      passRules: [
        (v) => !!v
          || 'Please use the password that has been sent to your mail-account',
      ],
      pinRules: [(v) => !!v || 'Email is required'],
    };
  },
  created() {
    this.$store.commit('setCurrentMainComponent', 'LoginPage');
  },
  beforeDestroy() {
    this.$store.commit('setCurrentMainComponent', '');
  },
  mounted() {
    // console.log('benjamin url', window.location.origin + '/' + $);
    if (this.mobilePhoneActive !== true) {}
    this.uniqueId = this.$route.params.uniqueId;
    // this.userType = this.$route.params.userType;
    this.stepId = this.$store.getters.getStepId;

    window.scrollTo({
      top: 0,
      left: 0,
      //  behavior: "smooth"
    });

    this.tmpUserType = 'u';

    if (!_.isEmpty(this.$store.getters.getUserActivationObject)) {
      this.userLogin = BaseObject._toLowerCaseObjectProperties(
        this.$store.getters.getUserActivationObject,
      );
      if (this.userLogin !== undefined) {
        this.userLogin.password = this.userName;
        this.tmpUser = new UserObject(
          this.userLogin.client_id,
          this.userLogin.email,
          'u',
          this.userLogin.password,
        );
        this.tmpUser.userlogin(
          (response) => {
            this.disableButton = false;
            this.loginSuccess = true;
            this.routeToNextPage();
          },
          (error) => {
            this.disableButton = false;
          },
        );
      }
    } else {
      // check which user is logged in
      if (
        this._user != null
        && (this._user.userData == undefined
          || (this._user.userData != undefined
            && this._user.userData.accountId != this.currentAccountId))
      ) {
        this.$store.commit('setSavePartnerId', '');
        this.$store.commit('setRedirectedFromPearlCalendar', false);
        this.$store.dispatch('auth/logout');
        this.$store.commit('auth/setUserType', 'u');
        this.$store.commit('setWebStepId', -1);
      } else {
        return;
      }
    }

    /**
     * if user is already logged in
     * move to the next screen
     */
    this.routeToNextPage();
  },
  methods: {
    appleLogin() {
      window.AppleID.auth.signIn().then((response) => {
        console.log('benajmin appleResponse, ', response);
        if (response.hasOwnProperty('error')) {
          console.log("Benjamin something went wrong", response);
          return;
        }
        let profile = {};
        profile.token = response.authorization.id_token;
        if (response.hasOwnProperty('user')) {
          if (response.hasOwnProperty('email')){
            profile.email = response.user.email;
          };
        } else {
          profile.email = '';
        };
        this.thirdPartySignIn('Apple', profile);
      });
    },
    facebookLogin() {
      window.FB.login((response) => {
        if (response.authResponse) {
          this.facebookLoginSucces();
        }
      });
    },
    facebookLoginSucces() {
      window.FB.api('/me', { fields: 'email' }, (response) => {
        let profile = {};
        profile.email = response.email;
        profile.token = window.FB.getAccessToken();
        this.thirdPartySignIn('Facebook', profile);
        window.FB.logout();
      });
    },
    googleLoginFailure() {
      console.log('failed to login');
    },
    googleLoginSucces(googleUser) {
      // Useful data for your client-side scripts:
      const profile = googleUser.getBasicProfile();
      let user = {};
      user.email = profile.getEmail();
      user.token = googleUser.getAuthResponse().id_token;
      this.thirdPartySignIn('Google', user);
    },
    thirdPartySignIn(type, profile) {
      const payload = {
        Email: profile.email,
        Token: profile.token,
        Type: type,
        client_id: appConfig.Userlogin.clientSecret,
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            'The call thirdPartySignIn on the account was successful',
            response,
          );
          this.loading = false;
          this.loginSuccess = true;
          store.commit("auth/setUserType", 'u');
          store.commit("auth/setUserName", response.data.UserId);
          store.commit("auth/setToken", response.data.AccessToken);
          store.commit("auth/setUserLevel", response.data.UserLevel);
          // UserObject.checkUserTags(response.data.UserId);
          console.log("check t ", response.data);
          if (response.data.UserLevel == 6 && response.data.PartnerId !== -1) {
            store.commit("auth/setPartnerId", response.data.PartnerId);
          } else {
            store.commit("auth/setPartnerId", -1)
          }
          if (response.data.PartnerId !== -1 && !!!this.getSavePartnerId ) {
            store.commit("setSavePartnerId", response.data.PartnerId);
          }
          UserObject.getUserDataStatic(
            (response) => {
              this.loginSuccess = true;
              this.disableButton = false;
              this.routeToNextPage();
            },
            (e) => {
              this.disableButton = false;
            },
          );
        },
        (error) => {
          console.log(
            'The call thirdPartySignIn on the account was not successful',
            error,
          );
        },
        'thirdPartySignIn',
        this.$store.getters.getCurrentAccountId,
        payload,
      );
    },
    resendLoginCodeEmail() {
      // This function resends the login mail to the user
      const payload = {
        Email: this.email,
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            'The call resendLoginCodeEmail on the account was successful',
            response,
          );
          this.mailSendedDialog = true;
        },
        (error) => {
          console.log(
            'The call resendLoginCodeEmail on the account was not successful',
            error,
          );
        },
        'resendLoginCodeEmail',
        this.$store.getters.getCurrentAccountId,
        payload,
      );
    },
    resendActivationEmail() {
      // This function resends the activation mail to the user
      const payload = {
        Email: this.email,
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            'The call resendActivationEmail on the account was successful',
            response,
          );
          this.mailSendedDialog = true;
        },
        (error) => {
          console.log(
            'The call resendActivationEmail on the account was not successful',
            error,
          );
        },
        'resendActivationEmail',
        this.$store.getters.getCurrentAccountId,
        payload,
      );
    },
    closeMailDialog() {
      this.mailSendedDialog = false;
      this.userForgotPassword = false;
      this.userNotActivated = false;
    },
    forgotPassword() {
      if (this.userNotActivated === true) {
        this.userNotActivated = false;
      }
      this.userForgotPassword = true;
    },
    // Submitting the login of the user
    submit() {
      if (this.$refs.form.validate()) {
        this.disableButton = true;
        this.tmpUser = new UserObject(
          this.uniqueId,
          this.email,
          'u',
          this.password,
        );
        console.log("Benjamin this.password", this.password);


        // 08-06-2020 Check if user is activated before logging in:
        const payload = {
          Email: this.email,
        };
        dssRequest.doRequest(
          (response) => {
            console.log(
              'The call isActivated on the account was successful',
              response,
            );
            if (response.data.Activated === true) {
              // User is indeed activated, continue to login
              this.tmpUser.userlogin(
                (response) => {
                  this.loginSuccess = true;
                  this.disableButton = false;
                  this.routeToNextPage();
                },
                (e) => {
                  this.disableButton = false;
                },
              );
            } else {
              // User is not activated, provide user with option to resend activation link
              if (this.userForgotPassword === true) {
                this.userForgotPassword = false;
              }
              this.userNotActivated = true;
              this.disableButton = false;
            }
          },
          (error) => {
            console.log(
              'The call isActivated on the account was not successful',
              error,
            );
            this.disableButton = false;
          },
          'isActivated',
          this.$store.getters.getCurrentAccountId,
          payload,
        );
      }
    },

    // Determines the user type and redirect to right screen.
    routeToNextPage() {
      if (this.$store.getters.getPartnerCreate) {
        this.$store.commit('setPartnerCreate', false);
        if (this.$store.getters['auth/userLevel'] > 3) {
          this.goTo('DashBoard');
          return;
        }

        window.EventBus.fire('goToCreatePartner', {});
        return;
      }
      if (this.$store.getters.getUserIsCreatingPassport) {
        this.goTo('PassportPage');
        this.$store.commit('setUserIsCreatingPassport', false);
        return;
      }
      if (!_.isEmpty(this.$store.getters.getChosenEvent)) {
        this.goTo('ActivityDetailScreen', { event_id: this.$store.getters.getChosenEvent });
        return;
      }
      if (!_.isEmpty(this.$store.getters.getSaveFavourite)) {
        this.goToHome();
      } else if (this.$store.getters.getRedirectedFromPearlCalendar && this.$store.getters['auth/userLevel'] > 0) {
        this.goToCalendar();
        return;
      } else if (_.isEmpty(this.$store.getters.getTripFormChosenTheme)) {
        if (
          this.$store.getters['auth/userLevel'] >= 1
          && this.$store.getters['auth/userLevel'] <= 3
        ) this.goToHome();
        if (
          this.$store.getters['auth/userLevel'] >= 4
          && this.$store.getters['auth/userLevel'] <= 9
        ) {
          this.goTo('DashBoard');
        }
      } else if (
        this.$store.getters['auth/userLevel'] >= 1
          && this.$store.getters['auth/userLevel'] <= 9
      ) this.goTo('MainEventInfo');
      this.$store.commit('auth/setUserType', this.tmpUserType);
      if (
        this.$store.getters['auth/userLevel'] == 0
        && this.tmpUserType == 't'
      ) {
        this.goTo('MainEventInfo');
      }
    },
    goToCalendar() {
      this.$router.push({
        name: 'Calendar',
        params: {
          account_id: this.$store.getters.getRegion,
          partner_id: Number(this.$store.getters.getSavePartnerId),
        },
      });
    },
    // Generic function to let the user move  to the landing page
    goToHome() {
      this.$router.push({
        name: 'Homepage',
        params: {
          account_id: this.$store.getters.getRegion,
        },
      });
    },
    // Generic function to let the user move to other component
    goTo(page, params = 'component') {
      // Generic function to let the user move to other component
      this.$router.push({
        name: page,
        params,
      });
    },

    // Retrieving the image from back-end
    headerImage() {
      const fileType = '.png';
      const image = appConfig.mainImages.headerImage;
      if (image == null) {
        return;
      }
      return require(`../assets/${image}${fileType}`);
    },
    // Retrieving the image from back-end
    previewImage() {
      const fileType = '.png';
      const image = appConfig.mainImages.previewImage;
      if (image == null) {
        return;
      }
      return require(`../assets/${image}${fileType}`);
    },
  },
};
</script>

<style scoped>
.outlineHeadText {
  margin-left: 3em;
  margin-top: -2.5em;
}

.outlineSecondText {
  margin-left: 4.5em;
}

.infoFromLinda {
  margin-left: 9em;
  margin-top: -8em;
}

.formOutline {
  margin-top: 2em;
}

.fontSize {
  font-size: 18px;
}

.lindaLogo {
  height: 25em;
  margin-left: -5.5em;
}

.lindaText {
  max-height: 15em;
  margin-left: -2.5em !important;
  margin: 15px;
  border-radius: 30px;
  max-width: 21em;
}

a {
  text-decoration: none !important;
}

.scrollingTrue {
  width: 98%;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 80vh;
}

.tri-right.left-in:after {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: -25px;
  right: auto;
  top: 30px;
  bottom: auto;
  border: 13px solid;
  border-color: #f2f2f2 #f2f2f2 transparent transparent;
}

.web_home_style {
  margin-bottom: 5em !important;
  width: auto;
  height: 85vh;
}
.passportImage {
  margin: 9em;
  margin-top: auto;
  margin-bottom: 5em;
}

.facebookBtn {
  width: 250px !important;
  height: 50px !important;
  cursor: pointer;
}
</style>
